/** id корневого узла внешнего чат-виджета «Сигнал» (containerId по умолчанию в его SDK). */
export const SIGNAL_WIDGET_ROOT_ID = "signal-widget-root";

/** Селектор для проверки «клик пришёл из виджета» — панель и кнопка телепортируются в body. */
export const SIGNAL_WIDGET_UI_SELECTOR = ".smart-assistant-panel, .smart-assistant-button";

/** Обычная страница обращения в поддержку — запасной путь, когда Ассистент недоступен. */
export const SUPPORT_CONTACT_ROUTE = "/app/eplex/support/contact";
